var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("标注历史")])]),_c('el-row',{attrs:{"gutter":10}},[_c('h3',[_vm._v("审核历史")]),_c('el-col',{attrs:{"span":6}},[_vm._v("10")])],1),_c('h3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }